/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import {
  UserMultipleRoles,
  UserMultipleRolesFromJSON,
  UserMultipleRolesFromJSONTyped,
  UserMultipleRolesToJSON,
} from "./UserMultipleRoles";

/**
 *
 * @export
 * @interface UserMultipleRolesListControllerResponse
 */
export interface UserMultipleRolesListControllerResponse {
  /**
   *
   * @type {Array<UserMultipleRoles>}
   * @memberof UserMultipleRolesListControllerResponse
   */
  data?: Array<UserMultipleRoles> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof UserMultipleRolesListControllerResponse
   */
  error?: ErrorResponse;
}

export function UserMultipleRolesListControllerResponseFromJSON(json: any): UserMultipleRolesListControllerResponse {
  return UserMultipleRolesListControllerResponseFromJSONTyped(json, false);
}

export function UserMultipleRolesListControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserMultipleRolesListControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
      ? null
      : (json["data"] as Array<any>).map(UserMultipleRolesFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function UserMultipleRolesListControllerResponseToJSON(
  value?: UserMultipleRolesListControllerResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
        ? null
        : (value.data as Array<any>).map(UserMultipleRolesToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
